"use strict";
var react_directive_1 = require("./react.directive");
exports.NguiReactDirective = react_directive_1.NguiReactDirective;
var react_module_1 = require("./react.module");
exports.NguiReactModule = react_module_1.NguiReactModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/react/dist/index.js
// module id = 554
// module chunks = 4